<template>
  <div class="upgrade-page-background">
    <div class="upgrade-page-container">
      <div class="panel pricing-table">

        <div class="pricing-plan">
          <!-- <img src="https://s22.postimg.cc/8mv5gn7w1/paper-plane.png" alt="" class="pricing-img"> -->
          <img src="/assets/illustrations/undraw_skateboard_nmbb.svg" alt="" class="pricing-img" />

          <h2 class="pricing-header">Starter</h2>
          <ul class="pricing-features">
            <li class="pricing-features-item">
              <strong class="d-block pb-3 text-left">Goalpilot&trade; core features:</strong>
              <el-popover
                placement="top"
                :open-delay="0"
                trigger="hover"
                width="400">
                <div>
                  INFO...
                  <img src="/assets/onboarding/dayplanner_drag.gif" style="max-width: 100%;" />
                </div>
                <a href="#" slot="reference" class="clickable">
                  <font-awesome-icon icon="calendar-alt" class="mr-2" />
                  Dayplanner<br />
                </a>
              </el-popover>
            </li>
            <li class="pricing-features-item"><strong>25</strong> goals</li>
            <li class="pricing-features-item"><strong>Unlimited</strong> tasks</li>
            <li class="pricing-features-item"><strong>1 GB</strong> of space</li>
            <!-- <li class="pricing-features-item"><strong>1</strong> visionboard</li> -->
          </ul>
          <!-- <span class="pricing-price">Free</span> -->
          <span class="pricing-price">$1.99 <small>/mo.</small></span>
          <!-- <a href="#/" class="pricing-button">Sign up</a> -->
          <template v-if="subscription === 'STARTER'">
            <span>You're currently on this plan</span>
          </template>
          <template v-else>
            <el-button size="fat" class="pricing-button" @click="onSelectPlan('starter')">Start 30 day trial</el-button>
          </template>
        </div>

        <div class="pricing-plan">
          <div class="ribbon">We <br> Recommend</div>
          <!-- <img src="https://s28.postimg.cc/ju5bnc3x9/plane.png" alt="" class="pricing-img"> -->
          <img src="/assets/illustrations/undraw_designer_life_w96d.svg" alt="" class="pricing-img" />
          <h2 class="pricing-header">Pro</h2>

          <ul class="pricing-features">
            <!-- <li class="pricing-features-item"><em>Everythin in Free +</em></li> -->
            <li class="pricing-features-item" style="text-align: left">
              <strong class="d-block pb-3 text-left">More aweseome features:</strong>
              <el-popover
                placement="top"
                :open-delay="0"
                trigger="hover"
                width="400">
                <div>
                  INFO...
                </div>
                <a href="#" slot="reference" class="clickable">
                  <font-awesome-icon icon="calendar-alt" class="mr-2" />
                  Fully featured calendar<br />
                </a>
              </el-popover>
              <font-awesome-icon icon="sequence-icon" class="mr-2" />Sequence manager<br />
              <font-awesome-icon icon="clock" class="mr-2" />Session recording and timeline<br />
              <font-awesome-icon icon="camera-retro" class="mr-2" />Visionboard<br />
            </li>
            <!-- <li class="pricing-features-item"><strong>Unlimited</strong> visionboards</li> -->
            <li class="pricing-features-item"><strong>Unlimited</strong> goals</li>
            <li class="pricing-features-item"><strong>10 GB</strong> of space</li>
          </ul>

          <span class="pricing-price">$15.99 <small>/mo.</small></span>
          <!-- <a href="#/" class="pricing-button is-featured">Free trial</a> -->
          <template v-if="subscription === 'PRO'">
            <span>You're currently on this plan</span>
          </template>
          <template v-else>
            <el-button type="primary" size="fat" class="pricing-button is-featured" @click="onSelectPlan('pro')">Start 7 day trial</el-button>
          </template>
        </div>

        <div class="pricing-plan" @mouseover="onHoverPlan">
          <!-- <img src="https://s21.postimg.cc/tpm0cge4n/space-ship.png" alt="" class="pricing-img"> -->
          <img src="/assets/illustrations/undraw_good_team_m7uu.svg" alt="" class="pricing-img" />
          <h2 class="pricing-header">Small team</h2>

          <ul class="pricing-features">
            <li class="pricing-features-item"><em>Everything in <strong>Pro</strong> plus...</em></li>
            <li class="pricing-features-item" style="text-align: left">
              <strong class="d-block pb-3 text-left">More aweseome features:</strong>
              <el-popover
                placement="top"
                :open-delay="0"
                trigger="hover"
                width="400">
                <div>
                  INFO...
                </div>
                <a href="#" slot="reference" class="clickable">
                  <font-awesome-icon icon="lightbulb" class="mr-2"/>
                  Team insights<br />
                </a>
              </el-popover>
            </li>
            <li class="pricing-features-item">Premium support</li>
            <!-- <li class="pricing-features-item">Participate in Referral-Programm</li> -->
          </ul>

          <span class="pricing-price">$21.99 <small>/seat/mo.</small></span>
          <!-- <span class="pricing-price">ask</span> -->
          <!-- <a href="#/" class="pricing-button is-featured">Free trial</a> -->
          <template v-if="subscription === 'TEAM'">
            <span>You're currently on this plan</span>
          </template>
          <template v-else>
            <el-button size="fat" class="pricing-button" @click="onSelectPlan('team')">Contact us</el-button>
          </template>
        </div>

        <!--
        <div class="pricing-plan">
          <img src="/assets/illustrations/undraw_good_team_m7uu.svg" alt="" class="pricing-img" />
          <h2 class="pricing-header">Enterprise</h2>
          <ul class="pricing-features">
            <li class="pricing-features-item">Dedicated</li>
            <li class="pricing-features-item">Enterprise support</li>
            <li class="pricing-features-item">On-premise installation</li>
            <li class="pricing-features-item">Simple horizontal scalability</li>
          </ul>
          <span class="pricing-price">$400</span>
          <a href="#/" class="pricing-button">Free trial</a>
        </div>
        -->

      </div>

      <!-- <pre class="mini-pre mt-2">{{subscription}}</pre> -->
      <!-- <pre class="mini-pre mt-2">{{userReadonly}}</pre> -->

      <!--
      <font-awesome-icon icon="bullseye" />
      <font-awesome-icon icon='trophy' />
      <font-awesome-icon icon="clock" />
      <font-awesome-icon icon="sliders-h" />
      <font-awesome-icon icon="wrench" />
      <font-awesome-icon icon="lightbulb" />
      <font-awesome-icon icon="sliders-h" />
      <font-awesome-icon icon="bug" />
      <font-awesome-icon icon="vote-yea" />
      -->
    </div>
  </div>
</template>

<script>
// Source: https://codepen.io/anon/pen/jjOroJ

// TODO: Integrate payment gateway

export default {
  name: 'UpgradePage',
  data() {
    return {};
  },
  computed: {
    userReadonly() {
      return this.$models.userReadonly.subscribeNode( this.$models.user.defaultUserId )
    },

    subscription() {
      return this.userReadonly.subscription.toUpperCase();
    },
  },
  methods: {
    onSelectPlan(plan) {
      console.log("onSelectPlan", plan)
      // TODO: Connect Payment Gateway

      this.$models.userReadonly.update(this.$models.user.defaultUserId, {
        subscription: plan
      })

      // TODO: Call cloud function
    },

    onHoverPlan() {
    },
  },
  components: {
  }
};
</script>

<style>
.upgrade-page-background {
  padding: 0 25px 25px;
  position: relative;
  width: 100%;
}

.upgrade-page-background::after {
  content: '';
  background: #409EFF;
  background: -moz-linear-gradient(top, white 0%, #409EFF 100%);
  background: -webkit-linear-gradient(top, white 0%, #409EFF 100%);
  background: linear-gradient(to bottom, white 0%, #409EFF 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='white', endColorstr='#409EFF', GradientType=0);
  height: 100%;
  min-height: 100vh;
  /* height: 200px; */
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}

@media (min-width: 900px) {
  .background {
    padding: 0 0 25px;
    height: 100%;
  }
}

.upgrade-page-container {
  margin: 0 auto;
  padding: 50px 0 0;
  max-width: 960px;
  width: 100%;
}

.panel {
  background-color: #fff;
  border-radius: 10px;
  /* padding: 15px 25px; */
  position: relative;
  width: 100%;
  z-index: 10;
}

.pricing-table {
  box-shadow: 0 10px 13px -6px rgba(0, 0, 0, 0.08), 0 20px 31px 3px rgba(0, 0, 0, 0.09), 0 8px 20px 7px rgba(0, 0, 0, 0.02);
  /* border: 1px solid #409eff; */
  display: flex;
  flex-direction: column;
}

@media (min-width: 900px) {
  .pricing-table {
    flex-direction: row;
  }
}

.pricing-table * {
  text-align: center;
}

.pricing-plan {
  border-bottom: 1px solid #d5e6f7;
  padding: 25px;

  /* NEU */
  overflow: hidden;
  position: relative;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pricing-plan:last-child {
  border-bottom: none;
}

@media (min-width: 900px) {
  .pricing-plan {
    border-bottom: none;
    border-right: 1px solid #d5e6f7;
    flex-basis: 100%;
    padding: 25px 50px;
  }

  .pricing-plan:last-child {
    border-right: none;
  }
}

.pricing-img {
  max-width: 100%;
  min-height: 200px;
  margin-bottom: 2em;
}

.pricing-header {
  color: #888;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 0;
}

.pricing-features {
  color: #204b77;
  padding: 0;
  /*
  font-weight: 600;
  letter-spacing: 1px;
  */
  margin: 25px 0 15px;
  flex: auto;
}

.pricing-features-item {
  border-top: 1px solid #d5e6f7;
  /* font-size: 12px; */
  line-height: 1.66;
  padding: 12px 0;
  text-align: left;
}

.pricing-features-item:last-child {
  border-bottom: 1px solid #d5e6f7;
}

.pricing-price {
  color: #204b77;
  display: block;
  font-size: 32px;
  font-weight: 700;
  margin: 15px 0;
}

.pricing-price small {
  font-size: 11pt;
  font-weight: 700;
}

.pricing-button {
  transition: all 150ms ease-in-out;
  display: block;
  width: 100%;
}
/*
.pricing-button {
  border: 1px solid #9dd1ff;
  border-radius: 10px;
  color: #348EFE;
  display: inline-block;
  margin: 25px 0;
  padding: 15px 35px;
  text-decoration: none;
  transition: all 150ms ease-in-out;
}

.pricing-button:hover,
.pricing-button:focus {
  background-color: #d5e6f7;
}

.pricing-button.is-featured {
  background-color: #48aaff;
  color: #fff;
}

.pricing-button.is-featured:hover,
.pricing-button.is-featured:active {
  background-color: #269aff;
}
*/

.ribbon {
  background: var(--blue);
  color: #fff;
  font-weight: 600;
  font-size: 0.9em;
  display: inline-block;
  padding: 50px 40px 10px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  top: -29px;
  left: -60px;
}

</style>
